export const getFontSize = (size?: number | string) => {
  if (!size) return 'inherit'
  if (typeof size === 'string' && !Number.isNaN(parseFloat(size))) return size
  return `${size}px`
}
